module.exports = __webpack_public_path__ + "img/ic_arrow_right.e360e8b7.svg";